import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import About from './pages/About';
import Blog from './pages/Blog';
import Home from './pages/Home';
const App = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/blog' element={<Blog />} />

          <Route path='*' element={<Home />} />
          {/* Je mets une route * ainsi tous les autres chemins tapés par erreur mène à l'accueil */}
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;